import React from 'react';
import {SortableContainer, SortableElement, SortEnd} from "react-sortable-hoc";
import {size} from "../../../models/size";
import {arrayMoveMutable} from 'array-move';

type SortableItemProps = {
  size: size
}

const SortableItem = SortableElement<SortableItemProps>(({size}: SortableItemProps) => (
  <div className="bg-white border p-2 m-1 cursor-pointer d-flex align-items-center">
    <p className="m-0 p-0">
      <i className="fa-solid fa-sort me-3" />
    </p>
    <p className="m-0 p-0">
      {size.label}
    </p>
  </div>
));

type SortableListProps = {
  sizeList: size[],
}

const SortableList = SortableContainer<SortableListProps>(({sizeList}: SortableListProps) => {
  return (
    <div>
      {sizeList.map((size, index) => (
        <SortableItem key={index} index={index} size={size}/>
      ))}
    </div>
  );
});

type SizeSortableProps = {
  size: size[],
}

export const SizeSortable = ({size}: SizeSortableProps) => {
  const onSortEnd = ({oldIndex, newIndex}: SortEnd) => {
    arrayMoveMutable(size, oldIndex, newIndex);
  };

  return (
    <>
      <div className="col p-2 max-w400px">
        <h3 className="h3 ms-2">Type</h3>
        <SortableList sizeList={size} onSortEnd={onSortEnd}/>
      </div>
    </>
  );
}
